import {
  aCustomEntityType,
  aCustomEntityTypePage,
  CustomEntityType,
  mockCustomEntityTypesQuery,
} from '__generated__';

export const getCustomEntityTypesQuery_create = (
  customEntityType: Partial<CustomEntityType>
) => {
  const customEntityTypes = aCustomEntityTypePage().objects;
  return mockCustomEntityTypesQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customEntityTypes: aCustomEntityTypePage({
          objects: [
            ...customEntityTypes,
            aCustomEntityType({
              id: '0',
              ...customEntityType,
            }),
          ],
        }),
      })
    );
  });
};

export const handlers = [
  mockCustomEntityTypesQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        __typename: 'Query',
        customEntityTypes: aCustomEntityTypePage(),
      })
    );
  }),
];
